export class OrderManagementCollections {
  static ModuleName = 'order-management';

  static OffStreetModuleName = 'off-street-management';

  static orders = `${OrderManagementCollections.ModuleName}/orders`;
  static EndUsers = `${OrderManagementCollections.ModuleName}/end-users`;
  static endUserOrders = `${OrderManagementCollections.EndUsers}/orders`;

  static subscriptionOrder = `${OrderManagementCollections.EndUsers}/subscription-orders`;
  static onStreetReservationOrder = `${OrderManagementCollections.EndUsers}/on-street-reservation-orders`;
  static onStreetReservations = `${OrderManagementCollections.ModuleName}/on-street-reservations`;
  static onStreetReservationEndUser = `${OrderManagementCollections.EndUsers}/on-street-reservation`;
  static publicOnStreetReservations = `${OrderManagementCollections.ModuleName}/public-on-street-reservations`;

  static PublicOffStreets = `${OrderManagementCollections.OffStreetModuleName}/public-off-street-reservations`;
  static publicOffStreet(offStreetReservationId: string){
    return `${OrderManagementCollections.PublicOffStreets}/${offStreetReservationId}`;
  }

  static order(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}`;
  }

  static endUserOrder(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}`;
  }

  static endUserOrderPublic(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/public`;
  }

  static paymentSubscriptionOrder(orderId: string) {
    return `${OrderManagementCollections.subscriptionOrder}/${orderId}/payment`;
  }

  static subscriptionOrderDetails(orderId: string) {
    return `${OrderManagementCollections.subscriptionOrder}/${orderId}`;
  }

  static extendOnStreetReservationOrder(orderId: string) {
    return `${OrderManagementCollections.onStreetReservationOrder}/${orderId}/extend`;
  }

  static onStreetOrderDetails(orderId: string) {
    return `${OrderManagementCollections.onStreetReservationOrder}/${orderId}`;
  }

  static completedOrder(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/completed`;
  }

  static processOrder(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/process`;
  }

  static cancelOrder(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/cancel`;
  }

  static payments(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/payments`;
  }

  static latestPayment(orderId: string) {
    return `${OrderManagementCollections.orders}/${orderId}/payments/latest`;
  }

  static orderookups() {
    return `${OrderManagementCollections.orders}/lookups`;
  }

  static publicOnStreetReservation(reservationId: string) {
    return `${OrderManagementCollections.publicOnStreetReservations}/${reservationId}`;
  }

  static extendPublicOnStreetReservation(reservationId: string) {
    return `${OrderManagementCollections.publicOnStreetReservations}/${reservationId}/extend`;
  }

  static walletLoadOnline = `${OrderManagementCollections.EndUsers}/wallet/load-online`;

  static offStreetOrders = `${OrderManagementCollections.EndUsers}/off-street-reservation-orders`;
  static offStreet = `${OrderManagementCollections.EndUsers}/off-street-reservation`;

  static offStreetOrder(orderId: string) {
    return `${OrderManagementCollections.offStreet}/${orderId}`;
  }

  static offStreetOrderByCode(code: string) {
    return `${OrderManagementCollections.offStreetOrders}/${code}`;
  }

  static settleOffStreetOrderForCustomer(code: string) {
    return `${OrderManagementCollections.offStreetOrders}/${code}/customer/settle`;
  }

  static settleOffStreetOrderForAnonymous(code: string) {
    return `${OrderManagementCollections.offStreetOrders}/${code}/anonymous/settle`;
  }

  static pickOffStreetOrder(code: string) {
    return `${OrderManagementCollections.offStreet}/pick/${code}`;
  }
}
